
export default (lang) => {
    const items = {
        'eng':'Eng',
        'ukr':'Ukr'
    }

    return items[lang]
}